var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pdp-set-picker" },
    [
      _vm.referenceMode
        ? _c("p", { staticClass: "pdp-set-picker__intro" }, [
            _vm._v("\n    I built one row per reference image — each\n    "),
            _vm._m(0),
            _vm._v(
              "\n    tile shows the source it'll be based on. Reorder, remove, or add rows, then\n    create your set.\n  "
            ),
          ])
        : _c("p", { staticClass: "pdp-set-picker__intro" }, [
            _vm._v("\n    For each image type, pick\n    "),
            _vm._m(1),
            _vm._v("\n    to generate a fresh image or\n    "),
            _vm._m(2),
            _vm._v(
              "\n    to use a pre-designed layout. I've pre-selected\n    " +
                _vm._s(_vm.initialRowCount) +
                " recommended types — all set to AI by default. Click\n    the Gallery tile on any row to swap that one.\n  "
            ),
          ]),
      _vm._v(" "),
      !_vm.referenceMode
        ? _c(
            "div",
            {
              staticClass: "pdp-set-picker__preset",
              class: { "is-open": _vm.presetOpen },
            },
            [
              _c(
                "button",
                {
                  staticClass: "pdp-set-picker__preset-trigger",
                  attrs: { type: "button", disabled: _vm.disabled },
                  on: { click: _vm.togglePresetDropdown },
                },
                [
                  _c("i", {
                    staticClass: "bi bi-soundwave pdp-set-picker__preset-icon",
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "pdp-set-picker__preset-label" }, [
                    _vm._v("Start from a sequence"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "pdp-set-picker__preset-value" }, [
                    _vm._v(
                      _vm._s(_vm.activePresetLabel || "Choose a preset...")
                    ),
                  ]),
                  _vm._v(" "),
                  _c("i", {
                    staticClass:
                      "bi bi-chevron-down pdp-set-picker__preset-chevron",
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.presetOpen,
                      expression: "presetOpen",
                    },
                  ],
                  staticClass: "pdp-set-picker__preset-menu",
                },
                _vm._l(_vm.presetSources, function (src) {
                  return _c(
                    "button",
                    {
                      key: src.id,
                      staticClass: "pdp-set-picker__preset-item",
                      class: { "is-active": src.id === _vm.activePresetId },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.selectPreset(src.id)
                        },
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(src.label) + " "),
                        _c(
                          "span",
                          { staticClass: "pdp-set-picker__preset-count" },
                          [_vm._v("· " + _vm._s(src.count))]
                        ),
                      ]),
                      _vm._v(" "),
                      src.id === _vm.activePresetId
                        ? _c("i", { staticClass: "bi bi-check-lg" })
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "pdp-set-picker__bulk" }, [
        _c("span", { staticClass: "pdp-set-picker__bulk-label" }, [
          _vm._v("Set all to:"),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "pdp-set-picker__bulk-btn",
            attrs: { type: "button", disabled: _vm.disabled },
            on: {
              click: function ($event) {
                return _vm.setAll("ai")
              },
            },
          },
          [_c("i", { staticClass: "bi bi-stars" }), _vm._v(" AI\n    ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "pdp-set-picker__bulk-btn",
            attrs: {
              type: "button",
              disabled: _vm.disabled || !_vm.anyTemplatesAvailable,
            },
            on: {
              click: function ($event) {
                return _vm.setAll("gallery")
              },
            },
          },
          [_c("i", { staticClass: "bi bi-image" }), _vm._v(" Gallery\n    ")]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { ref: "rowsList", staticClass: "pdp-set-picker__rows" },
        _vm._l(_vm.localRows, function (row, rowIdx) {
          return _c(
            "div",
            { key: row._uid, staticClass: "pdp-set-picker__row" },
            [
              _c("div", { staticClass: "pdp-set-picker__row-actions" }, [
                _c(
                  "span",
                  { staticClass: "drag-handle pdp-set-picker__row-action" },
                  [
                    _c("GripVerticalIcon", {
                      attrs: { width: 16, height: 16 },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pdp-set-picker__row-label" }, [
                _c("span", [_vm._v(_vm._s(row.label))]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "pdp-set-picker__row-action pdp-set-picker__row-action--remove",
                    attrs: {
                      type: "button",
                      disabled: _vm.disabled,
                      "aria-label": `Remove ${row.label} row`,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.removeRow(rowIdx)
                      },
                    },
                  },
                  [_c("i", { staticClass: "bi bi-x-lg" })]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pdp-set-picker__row-tiles-wrapper" }, [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.rowOverflow[rowIdx] &&
                          _vm.rowOverflow[rowIdx].canScrollLeft,
                        expression:
                          "rowOverflow[rowIdx] && rowOverflow[rowIdx].canScrollLeft",
                      },
                    ],
                    staticClass:
                      "pdp-set-picker__row-chevron pdp-set-picker__row-chevron--left",
                    attrs: { type: "button", "aria-label": "Scroll left" },
                    on: {
                      click: function ($event) {
                        return _vm.scrollRow(rowIdx, -1)
                      },
                    },
                  },
                  [_c("i", { staticClass: "bi bi-chevron-left" })]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    ref: "rowTiles",
                    refInFor: true,
                    staticClass: "pdp-set-picker__row-tiles",
                    on: {
                      scroll: function ($event) {
                        return _vm.onRowScroll(rowIdx)
                      },
                    },
                  },
                  [
                    _vm.isHeroRow(row)
                      ? [
                          _c(
                            "div",
                            { staticClass: "pdp-set-picker__tile-slot" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "pdp-set-picker__tile pdp-set-picker__tile--original",
                                  class: {
                                    "is-selected": row.mode === "original",
                                  },
                                  attrs: {
                                    type: "button",
                                    title: row.label,
                                    disabled: _vm.disabled,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setRowMode(rowIdx, "original")
                                    },
                                  },
                                },
                                [
                                  _vm.heroImageFor(row)
                                    ? _c("img", {
                                        attrs: {
                                          src: _vm.heroImageFor(row),
                                          alt: row.label,
                                        },
                                      })
                                    : _c("i", { staticClass: "bi bi-image" }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "pdp-set-picker__tile-original-label",
                                    },
                                    [_vm._v("Original")]
                                  ),
                                  _vm._v(" "),
                                  row.mode === "original"
                                    ? _c("i", {
                                        staticClass:
                                          "bi bi-check-circle-fill pdp-set-picker__tile-check",
                                      })
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.heroImageFor(row)
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "pdp-set-picker__tile-expand",
                                      attrs: {
                                        type: "button",
                                        "aria-label": "Preview image",
                                        disabled: _vm.disabled,
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          _vm.openImagePreview(
                                            _vm.heroImageFor(row),
                                            row.label
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "bi bi-arrows-angle-expand",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "pdp-set-picker__tile pdp-set-picker__tile--ai pdp-set-picker__tile--hero-alt",
                              class: { "is-selected": row.mode === "ai" },
                              attrs: { type: "button", disabled: _vm.disabled },
                              on: {
                                click: function ($event) {
                                  return _vm.setRowMode(rowIdx, "ai")
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "bi bi-stars" }),
                              _vm._v(" "),
                              _c("span", [_vm._v("AI")]),
                              _vm._v(" "),
                              row.mode === "ai"
                                ? _c("i", {
                                    staticClass:
                                      "bi bi-check-circle-fill pdp-set-picker__tile-check",
                                  })
                                : _vm._e(),
                            ]
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isHeroRow(row)
                      ? _c(
                          "div",
                          { staticClass: "pdp-set-picker__tile-slot" },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "pdp-set-picker__tile pdp-set-picker__tile--ai",
                                class: {
                                  "is-selected": row.mode === "ai",
                                  "pdp-set-picker__tile--ai-ref":
                                    !!row.reference_image_url,
                                },
                                attrs: {
                                  type: "button",
                                  disabled: _vm.disabled,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.setRowMode(rowIdx, "ai")
                                  },
                                },
                              },
                              [
                                row.reference_image_url
                                  ? [
                                      _c("img", {
                                        staticClass:
                                          "pdp-set-picker__tile-ref-img",
                                        attrs: {
                                          src: row.reference_image_url,
                                          alt: row.label,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm._m(3, true),
                                    ]
                                  : [
                                      _c("i", { staticClass: "bi bi-stars" }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("AI")]),
                                    ],
                                _vm._v(" "),
                                row.mode === "ai"
                                  ? _c("i", {
                                      staticClass:
                                        "bi bi-check-circle-fill pdp-set-picker__tile-check",
                                    })
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            row.reference_image_url
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "pdp-set-picker__tile-expand",
                                    attrs: {
                                      type: "button",
                                      "aria-label": "Preview image",
                                      disabled: _vm.disabled,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.openImagePreview(
                                          row.reference_image_url,
                                          row.label
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "bi bi-arrows-angle-expand",
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    row.type === "lifestyle"
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "pdp-set-picker__tile pdp-set-picker__tile--scene",
                            class: { "is-selected": row.mode === "scene" },
                            attrs: { type: "button", disabled: _vm.disabled },
                            on: {
                              click: function ($event) {
                                return _vm.setRowMode(rowIdx, "scene")
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "bi bi-image-alt" }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Scene")]),
                            _vm._v(" "),
                            row.mode === "scene"
                              ? _c("i", {
                                  staticClass:
                                    "bi bi-check-circle-fill pdp-set-picker__tile-check",
                                })
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.templatesForRow(row), function (tpl) {
                      return _c(
                        "div",
                        {
                          key: `${row.rowIndex}-${tpl.id}`,
                          staticClass:
                            "pdp-set-picker__tile pdp-set-picker__tile--tpl",
                          class: {
                            "is-selected":
                              row.mode === "gallery" &&
                              row.template_id === tpl.id,
                            "is-disabled": _vm.disabled,
                          },
                          attrs: {
                            role: "button",
                            tabindex: _vm.disabled ? -1 : 0,
                            "aria-pressed":
                              row.mode === "gallery" &&
                              row.template_id === tpl.id,
                            "aria-disabled": _vm.disabled,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onTemplateTileClick(rowIdx, tpl)
                            },
                            keydown: [
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                $event.preventDefault()
                                return _vm.onTemplateTileClick(rowIdx, tpl)
                              },
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "space",
                                    32,
                                    $event.key,
                                    [" ", "Spacebar"]
                                  )
                                )
                                  return null
                                $event.preventDefault()
                                return _vm.onTemplateTileClick(rowIdx, tpl)
                              },
                            ],
                          },
                        },
                        [
                          _c("img", {
                            attrs: { src: tpl.thumbnail, alt: tpl.name },
                          }),
                          _vm._v(" "),
                          row.mode === "gallery" && row.template_id === tpl.id
                            ? _c("i", {
                                staticClass:
                                  "bi bi-check-circle-fill pdp-set-picker__tile-check",
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "pdp-set-picker__tile-expand",
                              attrs: {
                                type: "button",
                                "aria-label": "Preview template",
                                disabled: _vm.disabled,
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.openLightbox(rowIdx, tpl)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "bi bi-arrows-angle-expand",
                              }),
                            ]
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.rowOverflow[rowIdx] &&
                          _vm.rowOverflow[rowIdx].canScrollRight,
                        expression:
                          "rowOverflow[rowIdx] && rowOverflow[rowIdx].canScrollRight",
                      },
                    ],
                    staticClass:
                      "pdp-set-picker__row-chevron pdp-set-picker__row-chevron--right",
                    attrs: { type: "button", "aria-label": "Scroll right" },
                    on: {
                      click: function ($event) {
                        return _vm.scrollRow(rowIdx, 1)
                      },
                    },
                  },
                  [_c("i", { staticClass: "bi bi-chevron-right" })]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "pdp-set-picker__yours-wrap",
                  class: {
                    "pdp-set-picker__hero-alt-wrap": _vm.isHeroRow(row),
                    "is-selected": row.mode === "yours",
                    "is-menu-open": _vm.yoursMenuIdx === rowIdx,
                  },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "pdp-set-picker__tile pdp-set-picker__tile--yours",
                      class: { "is-selected": row.mode === "yours" },
                      attrs: {
                        type: "button",
                        title:
                          "Use your own image (upload, File Browser, or Salsify)",
                        disabled: _vm.disabled,
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.toggleYoursMenu(rowIdx)
                        },
                      },
                    },
                    [
                      row.mode === "yours" &&
                      (row.own_image_thumb || row.own_image_url)
                        ? [
                            _c("img", {
                              attrs: {
                                src: row.own_image_thumb || row.own_image_url,
                                alt: row.label,
                              },
                            }),
                            _vm._v(" "),
                            _c("i", {
                              staticClass:
                                "bi bi-check-circle-fill pdp-set-picker__tile-check",
                            }),
                          ]
                        : [
                            _c("i", { staticClass: "bi bi-upload" }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Yours")]),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  row.mode === "yours" &&
                  (row.own_image_thumb || row.own_image_url)
                    ? _c(
                        "button",
                        {
                          staticClass: "pdp-set-picker__tile-expand",
                          attrs: {
                            type: "button",
                            "aria-label": "Preview image",
                            disabled: _vm.disabled,
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.openImagePreview(
                                row.own_image_url || row.own_image_thumb,
                                row.label
                              )
                            },
                          },
                        },
                        [_c("i", { staticClass: "bi bi-arrows-angle-expand" })]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.yoursMenuIdx === rowIdx
                    ? _c(
                        "div",
                        {
                          staticClass: "pdp-set-picker__yours-menu",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "pdp-set-picker__yours-menu-head" },
                            [
                              _vm._v(
                                "\n            USE YOUR OWN IMAGE\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "pdp-set-picker__yours-menu-item",
                              attrs: { type: "button", disabled: _vm.disabled },
                              on: {
                                click: function ($event) {
                                  return _vm.requestOwnImage(rowIdx, "upload")
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "bi bi-upload" }),
                              _vm._v(" Upload from computer...\n          "),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "pdp-set-picker__yours-menu-item",
                              attrs: { type: "button", disabled: _vm.disabled },
                              on: {
                                click: function ($event) {
                                  return _vm.requestOwnImage(rowIdx, "browser")
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "bi bi-folder2-open" }),
                              _vm._v(
                                " Choose from File Browser...\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "pdp-set-picker__yours-menu-item",
                              attrs: { type: "button", disabled: _vm.disabled },
                              on: {
                                click: function ($event) {
                                  return _vm.requestOwnImage(rowIdx, "salsify")
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "bi bi-bar-chart-steps" }),
                              _vm._v(" Pull from Salsify...\n          "),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _vm.isHeroRow(row) && row.mode === "original"
                ? _c("span", { staticClass: "pdp-set-picker__original-note" }, [
                    _vm._v("Used as-is — no AI changes"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.isHeroRow(row)
                ? _c(
                    "button",
                    {
                      staticClass:
                        "pdp-set-picker__tile pdp-set-picker__tile--add",
                      attrs: {
                        type: "button",
                        disabled: _vm.disabled,
                        "aria-label": "Open Design Gallery",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("open-gallery")
                        },
                      },
                    },
                    [_c("i", { staticClass: "bi bi-plus-lg" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "pdp-set-picker__row-spacer" }),
              _vm._v(" "),
              _vm.isGenerativeRow(row)
                ? _c("div", { staticClass: "pdp-set-picker__wand-wrap" }, [
                    _c(
                      "button",
                      {
                        staticClass: "pdp-set-picker__wand",
                        class: {
                          "is-active": _vm.hasDirection(row, rowIdx),
                          "is-open": _vm.directionOpenIdx === rowIdx,
                        },
                        attrs: {
                          type: "button",
                          title: "Add design direction (optional)",
                          disabled: _vm.disabled,
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.toggleDirection(rowIdx, $event)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "bi bi-magic" }),
                        _vm._v(" "),
                        _vm.hasDirection(row, rowIdx)
                          ? _c("span", {
                              staticClass: "pdp-set-picker__wand-dot",
                            })
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.directionOpenIdx === rowIdx
                      ? _c(
                          "div",
                          {
                            staticClass: "pdp-set-picker__direction",
                            class: { "is-above": _vm.directionAbove[rowIdx] },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "pdp-set-picker__direction-head" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "pdp-set-picker__direction-title",
                                  },
                                  [_vm._v("Customize " + _vm._s(row.label))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "pdp-set-picker__direction-optional",
                                  },
                                  [_vm._v("All optional")]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm._m(4, true),
                            _vm._v(" "),
                            _c("textarea", {
                              staticClass: "pdp-set-picker__direction-text",
                              attrs: {
                                rows: "3",
                                placeholder: _vm.directionPlaceholderFor(row),
                                disabled: _vm.disabled,
                              },
                              domProps: { value: row.userInstructions || "" },
                              on: {
                                input: function ($event) {
                                  return _vm.setRowDirection(
                                    rowIdx,
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "pdp-set-picker__direction-section",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "pdp-set-picker__direction-section-head",
                                  },
                                  [
                                    _c("FileTextIcon", {
                                      attrs: { width: 12, height: 12 },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pdp-set-picker__direction-label",
                                      },
                                      [_vm._v("Overlay text")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("textarea", {
                                  staticClass: "pdp-set-picker__direction-text",
                                  attrs: {
                                    rows: "3",
                                    placeholder: _vm.overlayTextPlaceholder,
                                    disabled: _vm.disabled,
                                  },
                                  domProps: { value: row.overlayText || "" },
                                  on: {
                                    input: function ($event) {
                                      return _vm.setRowOverlayText(
                                        rowIdx,
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "pdp-set-picker__overlay-mode",
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "pdp-set-picker__overlay-mode-btn",
                                        class: {
                                          "is-active":
                                            (row.overlayTextMode ||
                                              "editable") === "editable",
                                        },
                                      },
                                      [
                                        _c("input", {
                                          attrs: {
                                            type: "radio",
                                            name: `overlay-mode-${rowIdx}`,
                                            value: "editable",
                                            disabled: _vm.disabled,
                                          },
                                          domProps: {
                                            checked:
                                              (row.overlayTextMode ||
                                                "editable") === "editable",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.setRowOverlayTextMode(
                                                rowIdx,
                                                "editable"
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(
                                          "\n                Editable layer\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "pdp-set-picker__overlay-mode-btn",
                                        class: {
                                          "is-active":
                                            row.overlayTextMode ===
                                            "part_of_image",
                                        },
                                      },
                                      [
                                        _c("input", {
                                          attrs: {
                                            type: "radio",
                                            name: `overlay-mode-${rowIdx}`,
                                            value: "part_of_image",
                                            disabled: _vm.disabled,
                                          },
                                          domProps: {
                                            checked:
                                              row.overlayTextMode ===
                                              "part_of_image",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.setRowOverlayTextMode(
                                                rowIdx,
                                                "part_of_image"
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(
                                          "\n                Part of image\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "pdp-set-picker__direction-section",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "pdp-set-picker__direction-section-head",
                                  },
                                  [
                                    _c("ImageIcon", {
                                      attrs: { width: 12, height: 12 },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "pdp-set-picker__direction-label",
                                      },
                                      [_vm._v("Brand logo")]
                                    ),
                                    _vm._v(" "),
                                    _vm.brandLogoByRowIdx[rowIdx]
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "pdp-set-picker__logo-remove",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeBrandLogo(
                                                  rowIdx
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                Remove\n              "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.brandLogoByRowIdx[rowIdx]
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "pdp-set-picker__logo-selected",
                                      },
                                      [
                                        _c("img", {
                                          staticClass:
                                            "pdp-set-picker__logo-thumb-sm",
                                          attrs: {
                                            src: _vm.brandLogoByRowIdx[rowIdx]
                                              .url,
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "pdp-set-picker__logo-name",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.brandLogoByRowIdx[rowIdx]
                                                  .name || "Logo"
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "pdp-set-picker__logo-change",
                                            attrs: {
                                              type: "button",
                                              disabled: _vm.disabled,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.requestBrandLogo(
                                                  rowIdx
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                Change\n              "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "button",
                                      {
                                        staticClass: "pdp-set-picker__logo-btn",
                                        attrs: {
                                          type: "button",
                                          disabled: _vm.disabled,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.requestBrandLogo(rowIdx)
                                          },
                                        },
                                      },
                                      [
                                        _c("FolderOpenIcon", {
                                          attrs: { width: 14, height: 14 },
                                        }),
                                        _vm._v(
                                          "\n              Choose from Files\n            "
                                        ),
                                      ],
                                      1
                                    ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "separator w-100" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "pdp-set-picker__direction-foot" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "pdp-set-picker__direction-note",
                                  },
                                  [
                                    _vm._v(
                                      "Saved automatically · applies only to this image."
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "pdp-set-picker__direction-done",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        _vm.directionOpenIdx = null
                                      },
                                    },
                                  },
                                  [_vm._v("\n              Done\n            ")]
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.addableTypes.length
        ? _c("div", { staticClass: "pdp-set-picker__add-image-type" }, [
            _c(
              "button",
              {
                staticClass: "pdp-set-picker__add-trigger",
                class: { "is-open": _vm.addableTypesOpen },
                attrs: { type: "button", disabled: _vm.disabled },
                on: { click: _vm.toggleAddableTypesDropdown },
              },
              [
                _c("i", { staticClass: "bi bi-plus-lg" }),
                _vm._v(" Add image type\n      "),
                _c("span", [
                  _vm._v("(" + _vm._s(_vm.addableTypes.length) + ")"),
                ]),
                _vm._v(" "),
                _c("i", {
                  staticClass: "bi bi-chevron-down pdp-set-picker__add-chevron",
                }),
              ]
            ),
            _vm._v(" "),
            _vm.addableTypesOpen
              ? _c(
                  "div",
                  { staticClass: "pdp-set-picker__add-dropdown-menu" },
                  _vm._l(_vm.addableTypes, function (t) {
                    return _c(
                      "button",
                      {
                        key: t.key,
                        staticClass: "pdp-set-picker__add-item",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.addRow(t)
                          },
                        },
                      },
                      [_vm._v("\n        + " + _vm._s(t.label) + "\n      ")]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { ref: "footer", staticClass: "pdp-set-picker__footer" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary pdp-set-picker__create",
            attrs: {
              type: "button",
              disabled: _vm.disabled || !_vm.localRows.length,
            },
            on: {
              click: function ($event) {
                return _vm.confirm("parallel")
              },
            },
          },
          [
            _c("i", { staticClass: "bi bi-lightning-charge-fill" }),
            _vm._v(
              "\n      Create " +
                _vm._s(_vm.localRows.length) +
                " at once →\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "pdp-set-picker__create-sequential",
            attrs: {
              type: "button",
              disabled: _vm.disabled || !_vm.localRows.length,
            },
            on: {
              click: function ($event) {
                return _vm.confirm("sequential")
              },
            },
          },
          [_vm._v("\n      One at a time\n    ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "pdp-set-picker__browse",
            attrs: { type: "button", disabled: _vm.disabled },
            on: {
              click: function ($event) {
                return _vm.$emit("open-gallery")
              },
            },
          },
          [_vm._v("\n      Browse full gallery →\n    ")]
        ),
      ]),
      _vm._v(" "),
      _c("AIChatWidgetPdpTemplateLightbox", {
        attrs: {
          visible: !!_vm.lightbox.visible,
          template: _vm.lightbox.template || {},
          "is-selected": _vm.lightbox.isSelected,
        },
        on: {
          "select-template": _vm.onLightboxSelect,
          "deselect-template": _vm.onLightboxDeselect,
          close: _vm.closeLightbox,
        },
      }),
      _vm._v(" "),
      _vm.imagePreview.visible
        ? _c(
            "div",
            {
              staticClass: "pdp-set-picker__preview-lightbox",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  return _vm.closeImagePreviewModal.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "pdp-set-picker__preview-close",
                  attrs: { type: "button", "aria-label": "Close" },
                  on: { click: _vm.closeImagePreviewModal },
                },
                [_c("i", { staticClass: "bi bi-x-lg" })]
              ),
              _vm._v(" "),
              _c("img", {
                staticClass: "pdp-set-picker__preview-img",
                attrs: {
                  src: _vm.imagePreview.url,
                  alt: _vm.imagePreview.label,
                },
              }),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("b", [
      _c("i", { staticClass: "bi bi-stars pdp-set-picker__intro-icon" }),
      _vm._v(" AI"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("b", [
      _c("i", { staticClass: "bi bi-stars pdp-set-picker__intro-icon" }),
      _vm._v(" AI"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("b", [
      _c("i", { staticClass: "bi bi-image pdp-set-picker__intro-icon" }),
      _vm._v(" Gallery"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "pdp-set-picker__tile-ref-badge" }, [
      _c("i", { staticClass: "bi bi-stars" }),
      _vm._v(" AI\n                "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "pdp-set-picker__direction-section-head" },
      [
        _c("span", { staticClass: "pdp-set-picker__direction-label" }, [
          _vm._v("Direction"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }